export default "__VITE_ASSET__CfRT0VcX__"